import catalogSliders from "./catalogSliders.js";

import handleMarquee from "../modules/handleMarquee.js";

import filter from "./filter.js";
import catalogItem from "../catalogItem/catalogItem.js";
import {getElement} from "../modules/helpers.js";

export default function catalogPage() {
    if (document.querySelector('[data-page="catalog"]')) {
        catalogItem(productsFromLoop);
        catalogSliders();
        document.querySelectorAll('.catalog-item__descr').forEach(item => {
            const attrWrapper = item.querySelector('.catalog-item__filters');

            if (attrWrapper.querySelectorAll('[data-select-item]').length == 1 || attrWrapper.children.length == 0) {
                attrWrapper.classList.add('none');
            }


        })
        if (matchMedia("(min-width: 320px)" && "(max-width: 1199px)").matches) {
            const dropdowns = getElement('[data-target="sort"]', true);
            if (!dropdowns.length) return;
            dropdowns.forEach(dropdown => {
                console.log(dropdown)
                dropdown.addEventListener("click", (e) => {
                    if (e.target !== dropdown.querySelector('.dropdown__content') && !e.target.closest('.dropdown__content')) {
                        dropdown.classList.toggle("active");
                        if (matchMedia("(min-width: 320px)" && "(max-width: 767px)").matches) {
                            document.body.classList.toggle('active');
                        }
                    }
                });
                if (dropdown
                    .querySelector('[data-target="sort-by-close"]')) {
                    dropdown
                        .querySelector('[data-target="sort-by-close"]')
                        .addEventListener("click", (e) => {
                            dropdown.classList.toggle("active");
                            if (matchMedia("(min-width: 320px)" && "(max-width: 767px)").matches) {
                                document.body.classList.toggle('active');
                            }
                        });
                }

            })

        }
        handleMarquee();

    }
}
